/**
 * ContentSection Component
 * 
 * A wrapper for content sections with consistent spacing and layout.
 */

import React from 'react';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import { spacing } from '../../tokens';

export interface ContentSectionProps {
  /** Section content */
  children: React.ReactNode;
  /** Spacing between child elements */
  gap?: number;
  /** Additional styles */
  sx?: SxProps<Theme>;
}

export const ContentSection: React.FC<ContentSectionProps> = ({
  children,
  gap = 3,
  sx,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap,
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default ContentSection;

